<template>
    <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
            <v-chip
                x-small
                :color="chipColor"
                :text-color="textColor"
                v-bind="attrs"
                v-on="on"
                class="font-weight-bold"
            >
                <v-icon left x-small>{{ icon }}</v-icon>
                {{ label }}
            </v-chip>
        </template>
        <span>{{ tooltip }}</span>
    </v-tooltip>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'ProStatusBadge',
    
    computed: {
        ...mapGetters('auth', ['profileStatus', 'daysUntilExpiration', 'isPro', 'isStarter', 'isBlocked', 'isSysAdmin']),
        
        chipColor() {
            // Bloqueado (trial expirado)
            if (this.isBlocked) return 'error';
            
            // Starter
            if (this.isStarter) return 'grey';
            
            // Pro Permanente
            if (this.profileStatus.isPermanent) return 'primary';
            
            // Pro Temporário
            if (this.profileStatus.isExpired) return 'error';
            if (this.daysUntilExpiration <= 3) return 'error';
            if (this.daysUntilExpiration <= 7) return 'warning';
            if (this.daysUntilExpiration <= 30) return 'info';

            if (this.isSysAdmin) return 'black';
            return 'primary';
        },
        
        textColor() {
            return 'white';
        },
        
        icon() {
            if (this.isBlocked) return 'mdi-lock';
            if (this.isStarter) return 'mdi-account';
            if (this.profileStatus.isPermanent) return 'mdi-crown';
            if (this.profileStatus.isExpired) return 'mdi-alert-circle';
            if (this.isSysAdmin) return 'mdi-crown';
            return 'mdi-star';
        },
        
        label() {
            // Bloqueado
            if (this.isBlocked) return 'Bloqueado';
            
            // Starter
            if (this.isStarter) return 'Starter';
            
            // Pro Permanente
            if (this.profileStatus.isPermanent) return 'Premium';
            
            // Pro Expirado
            if (this.profileStatus.isExpired) return 'Expirado';

            if (this.isSysAdmin) return 'SysAdmin';
            
            // Pro Temporário
            if (this.daysUntilExpiration === 0) return 'Expira Hoje';
            if (this.daysUntilExpiration === 1) return 'Expira Amanhã';
            if (this.daysUntilExpiration <= 7) return `${this.daysUntilExpiration}d`;
            if (this.daysUntilExpiration <= 30) return `${this.daysUntilExpiration} dias`;
            return 'Premium';
        },
        
        tooltip() {
            // Bloqueado
            if (this.isBlocked) return 'Seu período de avaliação expirou. Escolha um plano para continuar.';
            
            // Starter
            if (this.isStarter) return 'Plano Starter';
            
            // Pro Permanente
            if (this.profileStatus.isPermanent) {
                return 'Plano Premium Permanente - Acesso ilimitado a todas as funcionalidades';
            }
            
            // Pro Expirado
            if (this.profileStatus.isExpired) {
                return 'Seu acesso Premium expirou. Entre em contato para renovar.';
            }

            if (this.isSysAdmin) return 'Você é um SysAdmin';
            
            // Pro Temporário
            const expirationDate = this.profileStatus.expiresAt;
            const formattedDate = expirationDate ? 
                new Intl.DateTimeFormat('pt-BR', { 
                    day: '2-digit', 
                    month: '2-digit', 
                    year: 'numeric' 
                }).format(expirationDate) : '';
            
            if (this.daysUntilExpiration === 0) {
                return `Seu acesso Pro expira hoje (${formattedDate})`;
            }
            
            if (this.daysUntilExpiration === 1) {
                return `Seu acesso Premium expira amanhã (${formattedDate})`;
            }
            
            return `Seu acesso Premium expira em ${this.daysUntilExpiration} dias (${formattedDate})`;
        }
    }
};
</script>
